import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

export function render(_ctx, _cache) {
  const _component_v_select = _resolveComponent("v-select")
  const _component_v_col = _resolveComponent("v-col")
  const _component_v_text_field = _resolveComponent("v-text-field")
  const _component_v_row = _resolveComponent("v-row")
  const _component_v_btn = _resolveComponent("v-btn")
  const _component_v_form = _resolveComponent("v-form")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_form, { ref: "form" }, {
      default: _withCtx(() => [
        (_ctx.postQualification.hasNameDetails)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "mb-4" }, "Personal data", -1)),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        label: _ctx.salutationData.label,
                        items: _ctx.salutations,
                        modelValue: _ctx.nameDetails.salutation,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.nameDetails.salutation) = $event)),
                        rules: _ctx.salutationData.rules,
                        "item-title": "name",
                        "item-value": "id",
                        variant: "outlined",
                        "validate-on": "blur"
                      }, null, 8, ["label", "items", "modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        label: _ctx.titleData.label,
                        modelValue: _ctx.nameDetails.title,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.nameDetails.title) = $event)),
                        rules: _ctx.titleData.rules,
                        variant: "outlined",
                        "validate-on": "blur"
                      }, null, 8, ["label", "modelValue", "rules"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        label: _ctx.firstNameData.label,
                        modelValue: _ctx.nameDetails.firstName,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.nameDetails.firstName) = $event)),
                        rules: _ctx.firstNameData.rules,
                        variant: "outlined",
                        "validate-on": "blur"
                      }, null, 8, ["label", "modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        label: _ctx.lastNameData.label,
                        modelValue: _ctx.nameDetails.lastName,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.nameDetails.lastName) = $event)),
                        rules: _ctx.lastNameData.rules,
                        variant: "outlined",
                        "validate-on": "blur"
                      }, null, 8, ["label", "modelValue", "rules"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.postQualification.hasAddressDetails)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _cache[14] || (_cache[14] = _createElementVNode("h2", { class: "mb-4" }, "Address", -1)),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        label: _ctx.addressTypesData.label,
                        items: _ctx.addressTypes,
                        modelValue: _ctx.addressDetails.addressType,
                        "onUpdate:modelValue": [
                          _cache[4] || (_cache[4] = $event => ((_ctx.addressDetails.addressType) = $event)),
                          _ctx.onAddressTypeInput
                        ],
                        rules: _ctx.addressTypesData.rules,
                        "item-title": "name",
                        "item-value": "id",
                        variant: "outlined",
                        "validate-on": "blur"
                      }, null, 8, ["label", "items", "modelValue", "rules", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "6" }, {
                    default: _withCtx(() => [
                      (_ctx.isBusinessAddress)
                        ? (_openBlock(), _createBlock(_component_v_text_field, {
                            key: 0,
                            label: _ctx.businessNameData.label,
                            modelValue: _ctx.addressDetails.buName,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.addressDetails.buName) = $event)),
                            rules: _ctx.businessNameData.rules,
                            variant: "outlined",
                            "validate-on": "blur"
                          }, null, 8, ["label", "modelValue", "rules"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        label: _ctx.streetData.label,
                        modelValue: _ctx.addressDetails.street,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.addressDetails.street) = $event)),
                        rules: _ctx.streetData.rules,
                        variant: "outlined",
                        "validate-on": "blur"
                      }, null, 8, ["label", "modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        label: _ctx.houseNumberData.label,
                        modelValue: _ctx.addressDetails.houseNumber,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.addressDetails.houseNumber) = $event)),
                        rules: _ctx.houseNumberData.rules,
                        variant: "outlined",
                        "validate-on": "blur"
                      }, null, 8, ["label", "modelValue", "rules"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        label: _ctx.zipCodeData.label,
                        modelValue: _ctx.addressDetails.zipCode,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.addressDetails.zipCode) = $event)),
                        rules: _ctx.zipCodeData.rules,
                        variant: "outlined",
                        "validate-on": "blur"
                      }, null, 8, ["label", "modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        label: _ctx.cityData.label,
                        modelValue: _ctx.addressDetails.city,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.addressDetails.city) = $event)),
                        rules: _ctx.cityData.rules,
                        variant: "outlined",
                        "validate-on": "blur"
                      }, null, 8, ["label", "modelValue", "rules"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        label: _ctx.countryData.label,
                        items: _ctx.countries,
                        modelValue: _ctx.addressDetails.countryCode,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((_ctx.addressDetails.countryCode) = $event)),
                        rules: _ctx.countryData.rules,
                        "item-title": "name",
                        "item-value": "code",
                        variant: "outlined",
                        "validate-on": "blur"
                      }, null, 8, ["label", "items", "modelValue", "rules"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.postQualification.hasCarDetails)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _cache[15] || (_cache[15] = _createElementVNode("h2", { class: "mb-4" }, "Vehicle data", -1)),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        label: _ctx.vinData.label,
                        modelValue: _ctx.carDetails.vin,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((_ctx.carDetails.vin) = $event)),
                        rules: _ctx.vinData.rules,
                        variant: "outlined",
                        "validate-on": "blur"
                      }, null, 8, ["label", "modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        items: _ctx.countries,
                        label: _ctx.countryOfRegistrationCode.label,
                        modelValue: _ctx.carDetails.countryOfRegistrationCode,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ((_ctx.carDetails.countryOfRegistrationCode) = $event)),
                        rules: _ctx.countryOfRegistrationCode.rules,
                        "item-title": "name",
                        "item-value": "code",
                        variant: "outlined",
                        "validate-on": "blur"
                      }, null, 8, ["items", "label", "modelValue", "rules"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_btn, {
          color: "primary",
          size: "large",
          variant: "flat",
          tile: "",
          loading: _ctx.isSubmitting,
          onClick: _ctx.submit
        }, {
          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
            _createTextVNode(" Send ", -1)
          ]))]),
          _: 1
        }, 8, ["loading", "onClick"])
      ]),
      _: 1
    }, 512)
  ]))
}